export const TicketRequestAllotmentTypes = {
  PERSONAL: 1,
  BUSINESS: 2,
};
